(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/context-menu/assets/javascripts/context-menu-button.js') >= 0) return;  svs.modules.push('/components/tipsen/context-menu/assets/javascripts/context-menu-button.js');
"use strict";

const _svs$ui = svs.ui,
  ReactButton = _svs$ui.ReactButton,
  ReactIcon = _svs$ui.ReactIcon;
const ContextMenuButton = _ref => {
  let children = _ref.children,
    dataTestId = _ref['data-testid'],
    icon = _ref.icon,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 100 : _ref$size;
  return React.createElement(ReactButton, {
    className: "f-left",
    "data-testid": dataTestId,
    disabled: isDisabled,
    iconPosition: "left",
    onClick: onClick,
    size: size,
    transparent: true
  }, React.createElement(ReactIcon, {
    icon: icon,
    size: "".concat(size)
  }), children ? children : null);
};
setGlobal('svs.components.tipsen.contextMenu.ContextMenuButton', ContextMenuButton);

 })(window);